/* */ 
'use strict';
var validateSchema = require('./validate-schema'),
    validateSpec = require('./validate-spec'),
    util = require('./util'),
    Options = require('./options'),
    Promise = require('./promise'),
    maybe = require('call-me-maybe'),
    ono = require('ono'),
    $RefParser = require('json-schema-ref-parser'),
    dereference = require('json-schema-ref-parser/lib/dereference');
module.exports = SwaggerParser;
function SwaggerParser() {
  $RefParser.apply(this, arguments);
}
util.inherits(SwaggerParser, $RefParser);
SwaggerParser.YAML = $RefParser.YAML;
SwaggerParser.parse = $RefParser.parse;
SwaggerParser.resolve = $RefParser.resolve;
SwaggerParser.bundle = $RefParser.bundle;
SwaggerParser.dereference = $RefParser.dereference;
Object.defineProperty(SwaggerParser.prototype, 'api', {
  configurable: true,
  enumerable: true,
  get: function() {
    return this.schema;
  }
});
SwaggerParser.prototype.parse = function(api, options, callback) {
  var args = normalizeArgs(arguments);
  return $RefParser.prototype.parse.call(this, args.path, args.api, args.options).then(function(schema) {
    var supportedSwaggerVersions = ['2.0'];
    if (schema.swagger === undefined || schema.info === undefined || schema.paths === undefined) {
      throw ono.syntax('%s is not a valid Swagger API definition', args.path || args.api);
    } else if (typeof schema.swagger === 'number') {
      throw ono.syntax('Swagger version number must be a string (e.g. "2.0") not a number.');
    } else if (typeof schema.info.version === 'number') {
      throw ono.syntax('API version number must be a string (e.g. "1.0.0") not a number.');
    } else if (supportedSwaggerVersions.indexOf(schema.swagger) === -1) {
      throw ono.syntax('Unsupported Swagger version: %d. Swagger Parser only supports version %s', schema.swagger, supportedSwaggerVersions.join(', '));
    }
    return maybe(args.callback, Promise.resolve(schema));
  }).catch(function(err) {
    return maybe(args.callback, Promise.reject(err));
  });
};
SwaggerParser.validate = function(api, options, callback) {
  var Class = this;
  var instance = new Class();
  return instance.validate.apply(instance, arguments);
};
SwaggerParser.prototype.validate = function(api, options, callback) {
  var me = this;
  var args = normalizeArgs(arguments);
  var circular$RefOption = args.options.dereference.circular;
  args.options.validate.schema && (args.options.dereference.circular = 'ignore');
  return this.dereference(args.path, args.api, args.options).then(function() {
    args.options.dereference.circular = circular$RefOption;
    if (args.options.validate.schema) {
      validateSchema(me.api);
      if (me.$refs.circular) {
        if (circular$RefOption === true) {
          dereference(me, args.options);
        } else if (circular$RefOption === false) {
          throw ono.reference('The API contains circular references');
        }
      }
    }
    if (args.options.validate.spec) {
      validateSpec(me.api);
    }
    return maybe(args.callback, Promise.resolve(me.schema));
  }).catch(function(err) {
    return maybe(args.callback, Promise.reject(err));
  });
};
function normalizeArgs(args) {
  var path,
      api,
      options,
      callback;
  args = Array.prototype.slice.call(args);
  if (typeof args[args.length - 1] === 'function') {
    callback = args.pop();
  }
  if (typeof args[0] === 'string') {
    path = args[0];
    if (typeof args[2] === 'object') {
      api = args[1];
      options = args[2];
    } else {
      api = undefined;
      options = args[1];
    }
  } else {
    path = '';
    api = args[0];
    options = args[1];
  }
  if (!(options instanceof Options)) {
    options = new Options(options);
  }
  return {
    path: path,
    api: api,
    options: options,
    callback: callback
  };
}
